import {MessageTypes} from "../../Utils/Constants";

/**
 * Counts how many messages a send will consume from the company's quota.
 *
 * SMS and WhatsApp both go to a phone, so choosing both costs two messages for every user
 * who has one. Shared by the notification counts display and by the Save button, so the
 * warning the admin reads and the button they click always agree on the same number.
 *
 * @param {object} params - The function parameters container object
 * @param {Array<string>} [params.messagingTypes] - Selected channels (MessageTypes values)
 * @param {number} [params.sendToUsersWithPhone] - Users reachable by phone
 * @param {number} [params.sendToUsersWithEmail] - Users reachable by email
 * @returns {number} Total messages that will be sent
 */
export const countMessagesToSend = ({messagingTypes = [], sendToUsersWithPhone = 0, sendToUsersWithEmail = 0}) => {
    const types = messagingTypes || [];
    const phoneCount = sendToUsersWithPhone || 0;
    const emailCount = sendToUsersWithEmail || 0;

    let total = 0;
    if (types.includes(MessageTypes.SMS)) {
        total += phoneCount;
    }
    if (types.includes(MessageTypes.EMAIL)) {
        total += emailCount;
    }
    if (types.includes(MessageTypes.WHATSAPP)) {
        total += phoneCount;
    }

    return total;
};

export const EntityTypes = {
    COURSE: 'COURSE',
    SIGN_DOC: 'SIGN_DOC'
}

export const SchedulingModes = {
    RELATIVE_TO_TASK_END: 'RELATIVE_TO_TASK_END',
    RECURRING_SCHEDULE: 'RECURRING_SCHEDULE'
}

export const AutomationTypes = {
    ONE_TIME: 'ONE_TIME',
    RECURRING: 'RECURRING'
}

export const AutomationStatuses = {
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
}

export const RecurringFrequencies = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY'
}